import { InfoOutlineIcon } from '@chakra-ui/icons';
import { Flex, Image, Text, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useGameColorsProvider } from 'src/providers/Theme/gameColorsProvider';
import Vendor from '../../../../vendor.config';
import { Color } from '../../../../theme/color';

export const AirdropInfo = ({ amount, price }: { amount: number; price: string }) => {
	const { t } = useTranslation();
	const { callToActionColor, callToActionTextColor } = useGameColorsProvider();

	return (
		<Flex
			alignItems="center"
			justifyContent="space-between"
			zIndex="1"
			gridGap="5px"
			padding="5px 26px"
			mt="-14px"
			bg={callToActionColor}
			borderRadius="0px 0px 8px 8px"
		>
			<Flex
				alignItems="center"
				gap="10px"
			>
				{/*todo: contrast*/}
				<Text
					color="#E2E8F0"
					fontSize="10px"
				>
					{t('airdrop.label')}
				</Text>
				<Tooltip
					hasArrow
					label={`${t('purchasePane.tooltip')}`}
					bg="black"
					p="10px"
					borderRadius="4px"
					fontSize="10px"
					color="white"
				>
					<InfoOutlineIcon
						cursor="pointer"
						ml="3px"
						color={Color.ACTION}
					/>
				</Tooltip>
			</Flex>
			<Flex
				alignItems="center"
				gap="5px"
			>
				<Text
					fontWeight="600"
					fontSize="16px"
					ml="15px"
				>
					{Math.round((amount * parseFloat(price)) / 500)}
				</Text>
				<Image
					maxH="16px"
					filter="grayscale(1)"
					src="/icons/hash_logo.svg"
				/>
			</Flex>
		</Flex>
	);
};
